// {{ date | dateFormat() }}
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import fromNow from "dayjs/plugin/relativeTime";

dayjs.extend(advancedFormat);
dayjs.extend(fromNow);

const DateFormat = (value: any, format: string) => {
  if (!value) return "";
  return dayjs(value).format(format);
};

const FromNow = (value: any, format: string) => {
  if (!value) return "";
  return dayjs(value).fromNow();
};

export { DateFormat, FromNow };
